import { makeStyles } from '@material-ui/core';
import { ThemeInstance } from 'configs/theme';

export const useStyles = makeStyles((theme: ThemeInstance) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      opacity: '.7',
    },
  },
  loader: {
    display: 'block',
    marginRight: 5,
  },
  attachIcon: {
    marginRight: 5,
    fontSize: '1.1rem',
    color: theme.custom.darkBlue,
  },
  name: {
    fontSize: 14,
    color: theme.custom.lightBlue,
    textDecoration: 'underline',
  },
  pointer: {
    cursor: 'pointer',
  },
}));
